export const generateGrid = (n = 24) => {
  const obj = {
    '& > .grid-stack-item': { width: `${100 / n}%` },
    '& > .grid-stack-item[gs-x="1"]': { left: `${100 / n}%` }
  }

  for (let i = 1; i <= n; i++) {
    const percent = `${(100 / n) * i}%`
    obj[`& > .grid-stack-item[gs-w="${i}"]`] = { width: percent }
    obj[`& > .grid-stack-item[gs-x="${i}"]`] = { left: percent }
  }

  return obj
}

export const rerenderGrid = async (window, el) => {
  const optimizedMode = el.getUserSettings('optimizedMode')
  const opts = optimizedMode
    ? {
        ...el.gridOptions,
        // minimal resizing and dragging,
        resizable: { handles: 'se' },
        draggable: {}
      }
    : el.gridOptions
  const isFreeformFalse = el.call('getCurrentCanvasPage')?.freeform === false
  opts.float = !isFreeformFalse
  // eslint-disable-next-line no-multi-assign
  const gs = (window.gs = window.GridStack.addGrid(el.node, opts))
  const gridItems = gs.getGridItems().map((v) => v.gridstackNode)
  await el.updateGridsInSchema(gridItems)
}
